var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCleanSterilize1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8361_2400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16C3 8.26801 9.26801 2 17 2H29C36.732 2 43 8.26801 43 16V28C43 35.732 36.732 42 29 42H17C9.26801 42 3 35.732 3 28V16Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_2400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1807 14.3449C22.2164 14.1537 22.3179 13.9811 22.4675 13.8568C22.6171 13.7326 22.8054 13.6646 22.9999 13.6646C23.1943 13.6646 23.3827 13.7326 23.5323 13.8568C23.6819 13.9811 23.7833 14.1537 23.819 14.3449L24.6949 18.9765C24.7571 19.3058 24.9171 19.6087 25.1541 19.8457C25.391 20.0826 25.6939 20.2427 26.0232 20.3049L30.6549 21.1807C30.846 21.2164 31.0187 21.3179 31.1429 21.4675C31.2672 21.6171 31.3352 21.8054 31.3352 21.9999C31.3352 22.1943 31.2672 22.3827 31.1429 22.5323C31.0187 22.6819 30.846 22.7833 30.6549 22.819L26.0232 23.6949C25.6939 23.7571 25.391 23.9171 25.1541 24.1541C24.9171 24.391 24.7571 24.6939 24.6949 25.0232L23.819 29.6549C23.7833 29.846 23.6819 30.0187 23.5323 30.1429C23.3827 30.2672 23.1943 30.3352 22.9999 30.3352C22.8054 30.3352 22.6171 30.2672 22.4675 30.1429C22.3179 30.0187 22.2164 29.846 22.1807 29.6549L21.3049 25.0232C21.2427 24.6939 21.0826 24.391 20.8457 24.1541C20.6087 23.9171 20.3058 23.7571 19.9765 23.6949L15.3449 22.819C15.1537 22.7833 14.9811 22.6819 14.8568 22.5323C14.7326 22.3827 14.6646 22.1943 14.6646 21.9999C14.6646 21.8054 14.7326 21.6171 14.8568 21.4675C14.9811 21.3179 15.1537 21.2164 15.3449 21.1807L19.9765 20.3049C20.3058 20.2427 20.6087 20.0826 20.8457 19.8457C21.0826 19.6087 21.2427 19.3058 21.3049 18.9765L22.1807 14.3449Z",
    stroke: "#E60076",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6665 13.6665V16.9998",
    stroke: "#E60076",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 15.3335H28",
    stroke: "#E60076",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3332 30.3333C17.2536 30.3333 17.9998 29.5871 17.9998 28.6667C17.9998 27.7462 17.2536 27 16.3332 27C15.4127 27 14.6665 27.7462 14.6665 28.6667C14.6665 29.5871 15.4127 30.3333 16.3332 30.3333Z",
    stroke: "#E60076",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8361_2400",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8361_2400"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8361_2400"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8361_2400",
    result: "effect2_dropShadow_8361_2400"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8361_2400",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_2400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanSterilize1Icon);
export default __webpack_public_path__ + "static/media/clean_sterilize_1_icon.30615178e747fc0fa6704ac2b70de6ac.svg";
export { ForwardRef as ReactComponent };